import type { Article } from 'types';

let activeVideo: HTMLVideoElement | undefined;
let deactivateVideo: (() => void) | undefined;

export function inlineVideoHref(article: Pick<Article, 'id' | 'articleType'>) {
	return `/${article.articleType === 'satsang' ? 'satsang' : 'video'}/${encodeURIComponent(article.id)}`;
}

export function pauseInlineVideo() {
	activeVideo?.pause();
}

export function activateInlineVideo(video: HTMLVideoElement, onDeactivate?: () => void) {
	if (activeVideo !== video) {
		activeVideo?.pause();
		deactivateVideo?.();
	}
	activeVideo = video;
	deactivateVideo = onDeactivate;
}

export function releaseInlineVideo(video: HTMLVideoElement) {
	video.pause();
	if (activeVideo === video) {
		activeVideo = undefined;
		deactivateVideo = undefined;
	}
}
